/**
 * 枚举类
 * 2018-09 jetty
 * deal select的options统一用map后缀并且是数组格式
 */

// 身份证对应省代码
export const IDPROVINCECODE = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外'
}
// 学历等级
export const EDULEVELS = {
    0: '未知',
    1: '小学肄业',
    2: '小学',
    3: '初中',
    4: '高中',
    5: '技术学校',
    6: '中专',
    7: '大专',
    8: '本科',
    9: '硕士',
    10: '博士',
    11: '博士后'
}
// 婚姻状态
export const MARRIAGESTATUS = {
    0: '未知',
    1: '未婚',
    2: '已婚无子女',
    3: '已婚有子女',
    4: '离婚',
    5: '其它'
}

export const LINKMAN = {
    0: '未知',
    1: '本人',
    2: '配偶',
    3: '子',
    4: '女',
    5: '孙子孙女或外孙外孙女',
    6: '父母',
    7: '祖父母或外祖父母',
    8: '兄弟姐妹',
    9: '法人',
    10: '法定代表人',
    11: '其它直系亲属',
    12: '旁系亲属',
    13: '被担保人',
    14: '投资关系',
    15: '被投资关系',
    16: '同事',
    17: '紧急联系人',
    18: '股东',
    19: '高管',
    20: '员工',
    21: '朋友',
    22: '同学',
    99: '其它'
}
